
import {Component, Vue} from "vue-property-decorator";

@Component
export default class AccountValidation extends Vue {
    private alertColor: string = "";
    private alertMessage: string = "";
    private mounted() {
        const token = this.$route.params.token;
        this.validateUser(token);
    }

    private validateUser(token) {
        this.$store.dispatch("auth/validateUser", {token})
            .then((res) => {
                this.alertColor = "green";
                this.alertMessage = "account.activated";
            })
            .catch((err) => {
                this.$store.commit("alerts/displayError", {
                    msg : err,
                });
            });
    }

}
